export default __webpack_public_path__ + "static/media/boosts-example.d99e89a7.png";